import OnboardingShell from "../components/layout/onboarding-shell";
import NotFoundTemplate from "../components/layout/404-template";
import Button from "../components/ui/button";
import ButtonContent from "../components/ui/button-content";
import { useRouter } from "next/router";
import { getCachedBusiness } from "../lib/utils";


const NotFound = () => {
  const router = useRouter()
  const handleReturnToDashboard = () => {
    router.push(`/${getCachedBusiness()}/dashboard`);
  };

  return (
    <OnboardingShell>
      <NotFoundTemplate />
      <Button handleClick={handleReturnToDashboard}>
        <ButtonContent>Return to Dashboard</ButtonContent>
      </Button>
    </OnboardingShell>
  );
};

NotFound.isUnprotected = true;
export default NotFound;
